import { render, staticRenderFns } from "./GeneralInstruction.vue?vue&type=template&id=0712c371&scoped=true"
import script from "./GeneralInstruction.vue?vue&type=script&lang=js"
export * from "./GeneralInstruction.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/W9_form/general.css?vue&type=style&index=0&id=0712c371&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712c371",
  null
  
)

export default component.exports